import { render, staticRenderFns } from "./AppLabel.vue?vue&type=template&id=59b74439&scoped=true&"
import script from "./AppLabel.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppLabel.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./AppLabel.vue?vue&type=style&index=0&id=59b74439&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b74439",
  null
  
)

export default component.exports